<template>
    <div>
        <span v-show="hasLabel" class="block text-sm font-medium text-gray-700">{{ label }}<span v-show="$attrs.required || false" class="text-teal font-bold">*</span></span>
        <div class="flex items-start" :class="{
            'mt-1': hasLabel
        }">
            <div class="h-5 flex items-center">
                <input :id="id" type="checkbox" :checked="modelValue" v-bind="$attrs" @change="handleInput($event)" class="focus:ring-teal h-4 w-4 text-teal border-gray-200 rounded">
            </div>
            <div class="ml-3 text-sm">
                <label :for="id" class="text-sm leading-5 font-medium text-gray-700 cursor-pointer">
                    <slot></slot>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        label: {
            type: String,
            default: ''
        },
        id: {
            type: String,
            default(){
                return 'checkbox-field-' + Math.random().toString(36).substr(2, 9);
            }
        },
        modelValue: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:modelValue'],
    setup(props, { emit }){
        function handleInput(e){
            emit('update:modelValue', e.target.checked);
        }

        return {
            handleInput
        }
    },
    computed: {
        hasLabel(){
            return this.label != '';
        }
    }
}
</script>

<style>

</style>
